import { render } from "./RegionDashboardsIndicatorCards.vue?vue&type=template&id=10818bf3&ts=true"
import script from "./RegionDashboardsIndicatorCards.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsIndicatorCards.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__